import React, { ReactNode } from "react";
import { Box } from "@mui/joy";

interface LayoutBoxProps {
  children: ReactNode;
  className?: string;
}

const LayoutBox: React.FC<LayoutBoxProps> = ({ children, className = "" }) => {
  return <Box className={`layout-box ${className}`.trim()}>{children}</Box>;
};

export default LayoutBox;
